import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturesBar from './components/FeaturesBar';
import ShopByActivity from './components/ShopByActivity';
import ProductGrid from './components/ProductGrid';
import SpecPanel from './components/SpecPanel';
import Bundles from './components/Bundles';
import ComparisonTable from './components/ComparisonTable';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-orange-600 selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <FeaturesBar />
        <ShopByActivity />
        <ProductGrid />
        <SpecPanel />
        <Bundles />
        <ComparisonTable />
        <Reviews />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;